import { Observable } from "rxjs/Observable"

import { postJSONConfig } from "./utils/network-config"

export function login(username, password) {
    const config = postJSONConfig({
        username,
        provider_token: password,
        provider: "email",
        force: true
    })
    return Observable.ajax
        .post(
            `${process.env.REACT_APP_GATEKEEPER_URI}/login`,
            config.body,
            config.headers
        )
        .map(response => response.response)
}

export function refreshToken(token) {
    const config = postJSONConfig({
        token
    })
    return Observable.ajax
        .post(
            `${process.env.REACT_APP_GATEKEEPER_URI}/login`,
            config.body,
            config.headers
        )
        .map(response => response.response)
}

export function forgot(email) {
    const config = postJSONConfig({ email })
    return Observable.ajax
        .post(
            `${process.env.REACT_APP_GATEKEEPER_URI}/forgot`,
            config.body,
            config.headers
        )
        .map(response => response.response)
}
